import { BaseActivity, ToBeDone } from '../types';

export enum ClassActivityPluralTypes {
  POLLS = 'polls',
  QUIZZES = 'quizzes',
  DISCUSSIONS = 'discussions',
  RESOURCES = 'resources',
}

/**
 * treat it as Abstract interface
 * should only be used for inheritance
 * do not use it directly anywhere
 **/
export interface ClassActivityListItem {
  activityId: MongoId;
  /** can be empty string or safe empty string (placeholder) */
  title: string;
  slug: string;
  /** rich text */
  hoverDetails: string;
  isAddedToPPT: boolean;
  isPublished: boolean;
}

export interface ClassActivity<T = ToBeDone> extends BaseActivity {
  classId: MongoId;
  toBeDone: T;
  /**
   * Activity due date and time,
   * `-1` means this activity does not have `dueDateTime`.
   * For manually-closed-activities it will be `-1` until the
   * activity is closed.
   */
  dueDateTime: UnixTime;
  /**
   * @deprecated - never used in ppt addon
   * Sequence number of the activity of it's type in a class.
   * `0` means this activity does not have a sequence number.
   */
  sequenceNum: number;
  /** `-1` when not published */
  publishedOn: UnixTime;
}

export interface PreviouslyUsedActivityCourseData<ClassActivity> {
  id: MongoId;
  code: string;
  title: string;
  startDate: UnixTime;
  endDate: UnixTime;
  activities: {
    classData: {
      id: MongoId;
      startTime: UnixTime;
    };
    activityData: ClassActivity;
  }[];
}
